import { useQuery } from '@tanstack/react-query'
import { fetchSpaceManagementData } from '@/lib/api/space-management'

/**
 * Query key factory for space management
 */
export const spaceManagementKeys = {
  all: ['space-management'] as const,
  lists: () => [...spaceManagementKeys.all, 'list'] as const,
  list: (locationId: string) =>
    [...spaceManagementKeys.lists(), locationId] as const,
}

/**
 * Fetch space management data for a location.
 * Combines units with area grouping, allocation counts,
 * and contract aircraft counts.
 */
export function useSpaceManagement(locationId: string | null) {
  return useQuery({
    queryKey: spaceManagementKeys.list(locationId || ''),
    queryFn: () => fetchSpaceManagementData(locationId!),
    enabled: !!locationId,
  })
}
